import { splitOrder, validateCart, ValidateCartApiParameter } from "@iewc/Services/CustomCartValidationService";
import setRedirectedFromCheckout from "@iewc/Store/Handlers/CheckoutShipping/CustomSetRedirected";
import { createHandlerChainRunner, Handler, HandlerProps } from "@insite/client-framework/HandlerCreator";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";

interface Parameter {
    apiParameter: ValidateCartApiParameter;
    onSuccess?: () => void;
}

interface Props {
    apiResult: any;
}

// create a handler chain
type HandlerType = Handler<Parameter, Props>;

// create a handler
const validateCartHandler: HandlerType = async props => {
    props.apiResult = await validateCart(props.parameter.apiParameter);
};

const dispatchSetRedirect: HandlerType = props => {
    if (props.apiResult.results && props.apiResult.results.length > 0) {
        props.dispatch({
            type: "Custom/CheckoutShipping/RedirectToCartPage",
            redirectToCartPage: true,
        } as any);
    }
};

const dispatchValidationResults: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutShipping/CartLines",
        cartLines: props.apiResult.results,
    } as any);
};

const dispatchValidateSplitOrder: HandlerType = async props => {
    const results = await splitOrder({
        t: Date.now().toString(),
    });

    if (results) {
        // eslint-disable-next-line no-console
        console.log("Split order results: ", results);
    }
};

const chain = [validateCartHandler, dispatchSetRedirect, dispatchValidationResults, dispatchValidateSplitOrder];

const customValidateCart = createHandlerChainRunner(chain, "CustomValidateCart");
export default customValidateCart;
